
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/[page]",
      function () {
        return require("private-next-pages/resources/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/[page]"])
      });
    }
  